import MuiButtonGroup, { ButtonGroupProps } from "@mui/material/ButtonGroup";

export const ButtonGroup = (props: ButtonGroupProps) => {
    return <MuiButtonGroup {...props} />
}